import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import { updateData } from "../../Config/functions";
import AssessmentDataService from "../../services/Assessment";
export const SendAppDownloadNotificationModal = ({
  isOpen,
  onClose,
  row,
  id,
  func,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");

  const handleSendNotification = () => {
    let template: string = "app_download";

    const clientData: any = [
      {
        phone_number: "91" + row.data.client_information.phone,
        name: row.data.client_information.name,
        dynamic_data:{}
      },
    ];
    const data: any = updateData(
      row,
      row.data.expert,
      "App Download Notification",
      row.data.new_lead_status,
      "app_download"
    );
    const templateName = template;
    AssessmentDataService.sendMessage(
      {
        templateName: templateName,
        clientdata: clientData,
      },
      token
    )
      .then((res) => {

        AssessmentDataService.update(data, id, token)
          .then((response: any) => {
            func()
            onClose();
          })
          .catch((e: Error) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to send notification?</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSendNotification}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
